var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600.59 600.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#021689;}.cls-2{fill:#e63612;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_2-2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2-2",
    "data-name": "Livello 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.93,0C138,.66,6.67,128,.09,287.86L0,310.3C5.2,471,136.78,600.05,298.91,600.76c165.89.72,301-133.17,301.68-299.08S467.41.73,301.52,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 287.1,
    y: 295.1,
    height: 10.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249,220.44l-.34-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.48,252.84H284.12c.34.56.67,1.12,1,1.68-.33-.56-.66-1.12-1-1.67a93.45,93.45,0,0,0-7.65-10.57H257.38a77.29,77.29,0,0,1,10.21,10.57,76,76,0,0,1,7.1,10.57h0A76,76,0,0,1,279.45,274h14.39a88.45,88.45,0,0,0-4-10.56H326a77.19,77.19,0,0,1,7-10.59h0a77.37,77.37,0,0,1,10.22-10.57H324.13A94.24,94.24,0,0,0,316.48,252.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.79,210.39l-182.53.12h-.33s-5.1.05-5.54.07v9.87h0v-9.87a89.93,89.93,0,1,0,93.14,95.1h5.54a89.93,89.93,0,1,0,89.72-95.28Zm-41.2,10.05h0a89.78,89.78,0,0,0-16.89,11.28H265.9A90.34,90.34,0,0,0,249,220.44Zm-102.58,0h0l-.34-.17ZM392.79,376.8a76.37,76.37,0,0,1-76.16-71.14h0c-.13-1.75-.27-3.5-.27-5.28s.14-3.52.27-5.28h0a76.86,76.86,0,0,1,1.4-10.57A74.39,74.39,0,0,1,321.15,274h0a75.78,75.78,0,0,1,4.78-10.55H310.81A86.27,86.27,0,0,0,306.76,274h0a88.92,88.92,0,0,0-2.48,10.56,94,94,0,0,0-1.22,10.57h-5.53a89.14,89.14,0,0,0-1.22-10.56h0A89,89,0,0,0,293.84,274H279.45a74.78,74.78,0,0,1,3.12,10.56h0a76.7,76.7,0,1,1-41.36-52.81h0a76.73,76.73,0,0,1,16.16,10.56h85.82a76.8,76.8,0,0,1,16.17-10.56h0a76.39,76.39,0,1,1,33.4,145.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M296.32,284.54h8A92.53,92.53,0,0,1,306.76,274H293.84A88.61,88.61,0,0,1,296.32,284.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.7,249.84a49.88,49.88,0,1,0,49.88,49.88h0A49.94,49.94,0,0,0,207.7,249.84Zm0,89.19A39.31,39.31,0,1,1,247,299.71h0A39.36,39.36,0,0,1,207.7,339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394,249.84a49.88,49.88,0,1,0,49.9,49.88A49.88,49.88,0,0,0,394,249.84ZM394,339a39.31,39.31,0,1,1,39.32-39.31A39.31,39.31,0,0,1,394,339Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.a11263d0afd4603426810905c60681d8.svg";
export { ForwardRef as ReactComponent };